var _defs, _g, _g2, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g3, _path14, _path15, _path16, _g4, _path17, _path18, _g5, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path19, _path20, _path21, _rect8, _rect9, _path22, _path23, _path24, _rect10, _rect11, _path25, _path26, _path27, _path28, _path29, _path30, _g6, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect12, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _rect13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 651.333,
    height: 380.596,
    viewBox: "0 0 651.333 380.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 2.471,
    height: 17.09,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 26.659,
    height: 16.332,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 215.413,
    height: 40.823,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 11.523,
    height: 3.971,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196",
    transform: "translate(10.821 12.647)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204",
    transform: "translate(96.785 119.312)",
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M148.111,1.907s109.842,15.625,99.618,43.656,54.661-9.956,80.556.15c18.435,7.2,11.065,29.1,19.984,37.925,20.449,20.236,41.362-5.247,67.388,10.043s-3.913,154.966-14.51,154.946l-387.747.01s-28.716-38.334-2.071-62.318,8.351-34.951,5.112-44.22c-3.718-10.643-17.032-41.029,20.9-54.332,27.49-9.642,28.226-43.351,27.11-49.467,0,0-10.632-48.373,83.664-36.392",
    fill: "#fff",
    opacity: 0.579
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    transform: "translate(-10.821 -12.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M87.242,35.964,0,220.7v36.91H121.17V304.4h39.52v-46.79h26.657V220.7H160.69V148H121.17v72.7H44.553L131.8,35.964Z",
    transform: "translate(0 -30.37)",
    fill: "#00b5bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M1586.273,279.618q-27.4,0-48.468-12.024a87.209,87.209,0,0,1-33.089-33.089q-12.024-21.064-12.024-48.468V93.575q0-27.4,12.024-48.468a87.229,87.229,0,0,1,33.089-33.089Q1558.869,0,1586.273,0t48.468,12.024a87.246,87.246,0,0,1,33.089,33.089q12.024,21.068,12.024,48.468v92.463q0,27.4-12.024,48.468a87.225,87.225,0,0,1-33.089,33.089q-21.068,12.023-48.468,12.024m0-37.283a52.53,52.53,0,0,0,27.123-7.177,54.433,54.433,0,0,0,19.481-19.387,52.358,52.358,0,0,0,7.27-27.31V90.779a52.02,52.02,0,0,0-7.27-27.123A54.473,54.473,0,0,0,1613.4,44.269a54.841,54.841,0,0,0-54.247,0,54.448,54.448,0,0,0-19.481,19.387,52.019,52.019,0,0,0-7.27,27.123v97.682a52.357,52.357,0,0,0,7.27,27.31,54.408,54.408,0,0,0,19.481,19.387,52.513,52.513,0,0,0,27.123,7.177",
    transform: "translate(-1260.609 0.005)",
    fill: "#00b5bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M3105.37,304.4v-46.79H2984.2V220.7l87.242-184.737H3116L3028.753,220.7h76.617V148h39.52v72.7h26.658v36.91H3144.89V304.4Z",
    transform: "translate(-2520.215 -30.372)",
    fill: "#00b5bd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(0.078 2.559)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M1950.263,1380.319l-.68-.277c2.016-4.962,3.338-15.219,2.546-25.183-.893-11.233.179-17.226.19-17.285l.722.133c-.011.058-1.064,5.97-.18,17.094.8,10.082-.537,20.447-2.6,25.519",
    transform: "translate(-1656.605 -1136.567)",
    fill: "#c5ddf9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M1921.655,2312.589a13.671,13.671,0,0,0-9.73-4.03h-35.353a13.67,13.67,0,0,0-9.73,4.03l-4.684,4.684,1.948,1.948,4.684-4.684a10.934,10.934,0,0,1,7.782-3.224h35.353a10.935,10.935,0,0,1,7.782,3.224l4.684,4.684,1.948-1.948Z",
    transform: "translate(-1582.317 -1961.635)",
    fill: "#23cccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 2.609,
    height: 186.149,
    transform: "translate(310.728 160.775)",
    fill: "#23cccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M2062.862,2293.269h-5.687v-2.175a.529.529,0,0,1,.529-.53h4.628a.529.529,0,0,1,.53.53Z",
    transform: "translate(-1748.03 -1946.345)",
    fill: "#81b4da"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M2067.748,1071.432h-3.334a.154.154,0,0,1-.154-.155v-1.27a.154.154,0,0,1,.154-.155h3.334a.155.155,0,0,1,.155.155v1.27a.155.155,0,0,1-.155.155",
    transform: "translate(-1754.048 -909.078)",
    fill: "#13375b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M1990.545,1109.944h-.112a.5.5,0,0,0-.494.458,4.756,4.756,0,0,1-9.467,0,.5.5,0,0,0-.494-.458h-12.723a.5.5,0,0,0-.494.458,4.756,4.756,0,0,1-9.467,0,.5.5,0,0,0-.494-.458h-.112a.492.492,0,0,0-.494.529,5.844,5.844,0,0,0,7.513,5.078l-.011.025a5.879,5.879,0,0,0,4.1-4.322.494.494,0,0,1,.481-.385h10.676a.494.494,0,0,1,.481.385,5.878,5.878,0,0,0,4.1,4.321l-.011-.025a5.844,5.844,0,0,0,7.513-5.078.492.492,0,0,0-.494-.529",
    transform: "translate(-1662.222 -943.144)",
    fill: "#13375b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M2249.8,2344.061a6.27,6.27,0,1,1-6.27-6.27,6.27,6.27,0,0,1,6.27,6.27",
    transform: "translate(-1901.056 -1986.474)",
    fill: "#81b4da"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M2263.395,2360.571a3.35,3.35,0,1,1-3.35-3.35,3.351,3.351,0,0,1,3.35,3.35",
    transform: "translate(-1917.564 -2002.984)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M1840.041,2344.061a6.27,6.27,0,1,1-6.27-6.27,6.27,6.27,0,0,1,6.27,6.27",
    transform: "translate(-1552.869 -1986.474)",
    fill: "#81b4da"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M1853.631,2360.571a3.35,3.35,0,1,1-3.35-3.35,3.35,3.35,0,0,1,3.35,3.35",
    transform: "translate(-1569.38 -2002.984)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M1898.984,1144.636a2.961,2.961,0,0,0,1.089,2.294,12.457,12.457,0,0,0,8.076,2.537l.017,1.315a1.39,1.39,0,0,0,2.781-.035l-.017-1.314a12.591,12.591,0,0,0,8.338-2.749,2.96,2.96,0,0,0,1.029-2.321l-.542-21.166a2.754,2.754,0,0,0-2.253-2.638l-2.311-.427a1.553,1.553,0,0,1-.927-.553l-.906-1.125a1.289,1.289,0,0,0-1.02-.48l-6.074.078a1.289,1.289,0,0,0-1.007.506l-.877,1.148a1.554,1.554,0,0,1-.912.576l-2.3.486a2.754,2.754,0,0,0-2.185,2.7Zm11.475-24.173a1.127,1.127,0,1,1-1.141-1.112,1.127,1.127,0,0,1,1.141,1.112",
    transform: "translate(-1613.608 -949.967)",
    fill: "#c5ddf9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M1924.892,1164.218a1.054,1.054,0,0,1,.929,1.016l.431,16.787a2.57,2.57,0,0,1-.9,2.021,11.263,11.263,0,0,1-7.682,2.393q-.715-.01-1.43.018a11.262,11.262,0,0,1-7.741-2.2,2.569,2.569,0,0,1-.956-2v-16.939a1.054,1.054,0,0,1,.915-1.041,65.392,65.392,0,0,1,16.437-.063",
    transform: "translate(-1620.88 -988.846)",
    fill: "#daeef7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M1913.138,1205.411l8.368,1.14,8.344-2.208.005-.009.292,11.418a2.364,2.364,0,0,1-.822,1.853,10.179,10.179,0,0,1-6.982,2.193q-.65-.009-1.3.017a10.179,10.179,0,0,1-7.036-2.013,2.362,2.362,0,0,1-.869-1.831Z",
    transform: "translate(-1625.637 -1023.35)",
    fill: "#f47458"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M1929.728,1199.1s-7.1,2.167-11.363-.16-7.934,1.1-3.026,3.564c5.039,2.534,14.39-3.4,14.39-3.4",
    transform: "translate(-1625.516 -1018.11)",
    fill: "#b75742"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183",
    transform: "translate(288.018 176.559)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M1917.5,1191.979l.852-.011a.709.709,0,0,0,.7-.718l-.2-15.662a.709.709,0,0,0-.718-.7l-.852.011a.709.709,0,0,0-.7.718l.2,15.662a.709.709,0,0,0,.718.7",
    transform: "translate(-1916.581 -1174.89)",
    fill: "#fff"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M1959.069,1113.66a4.751,4.751,0,0,1-1.775-3.258.5.5,0,0,0-.493-.458h-.112a.492.492,0,0,0-.494.529,5.854,5.854,0,0,0,2.318,4.151,1.366,1.366,0,0,0,.557-.965",
    transform: "translate(-1662.222 -943.144)",
    fill: "#13375b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M1299.686,1572.571a5.388,5.388,0,0,1,3.29-3.96c5.644-2.376,11.926.3,17.508,2.867,17.206,7.922,6.21,16.908,2.355,16.082-4.313-1.22-11.118-2.486-15.287-4.034-2.578-1.327-3.279-3.619-4.479-5.935-2.873-1.03-3.741-2.992-3.386-5.02",
    transform: "translate(-1104.309 -1332.101)",
    fill: "#b9c5ef"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M1299.686,1572.571a5.388,5.388,0,0,1,3.29-3.96c5.644-2.376,11.926.3,17.508,2.867,17.206,7.922,6.21,16.908,2.355,16.082-4.313-1.22-11.118-2.486-15.287-4.034-2.578-1.327-3.279-3.619-4.479-5.935-2.873-1.03-3.741-2.992-3.386-5.02",
    transform: "translate(-1104.309 -1332.101)",
    fill: "#9ecfe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186",
    transform: "translate(195.302 239.181)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M1316.894,1595.38c-5.44-2.5-11.546-5.105-17.078-3.034a4.785,4.785,0,0,0-.129.538c-.355,2.028.513,3.99,3.386,5.02,1.2,2.316,1.9,4.608,4.479,5.935,4.169,1.548,10.973,2.814,15.286,4.034a4.71,4.71,0,0,0,2.9-.6c1.475-3.178.29-7.684-8.845-11.89",
    transform: "translate(-1299.612 -1591.594)",
    fill: "#b9c5ef"
  }))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M1276.318,1794.641l-1.984,4.739a.913.913,0,0,1-1.194.489l-76.813-32.165a.913.913,0,0,1-.489-1.194l1.984-4.739a.913.913,0,0,1,1.195-.49l76.813,32.165a.913.913,0,0,1,.489,1.194",
    transform: "translate(-1016.07 -1496.541)",
    fill: "#13375b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M1462.275,1640.5h-138.1l-62.152-26.808a7.389,7.389,0,0,0-5.853,13.57l64.271,27.723a7.35,7.35,0,0,0,3.167.594v3.939h138.671a9.509,9.509,0,0,0,0-19.017",
    transform: "translate(-1063.6 -1370.672)",
    fill: "#d2e7f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(189.945 248.018)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M1472.688,1691.227h.124c8.316-.107,8.929-12.512.655-13.359a9.6,9.6,0,0,0-.979-.05h-138.1l-62.151-26.809a7.353,7.353,0,0,0-5.345-.195,4.389,4.389,0,0,0-.366,8.131l.058.025,64.271,27.723a7.346,7.346,0,0,0,3.167.594v3.939Z",
    transform: "translate(-1263.957 -1650.405)",
    fill: "#d2e7f3"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 2.074,
    height: 97.589,
    transform: "translate(263.359 304.919) rotate(-72.971)",
    fill: "#13375b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 97.589,
    height: 2.074,
    transform: "translate(263.359 331.514) rotate(-17.029)",
    fill: "#13375b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 230.565,
    height: 8.486,
    transform: "translate(183.848 298.742)",
    fill: "#66a1ff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 207.138,
    height: 5.875,
    transform: "translate(200.389 329.205)",
    fill: "#13375b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 3.917,
    height: 21.977,
    transform: "translate(235.689 307.228)",
    fill: "#13375b"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 3.917,
    height: 21.977,
    transform: "translate(378.374 307.228)",
    fill: "#13375b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M1373.943,2321.687a8.007,8.007,0,1,1-8.007-8.007,8.007,8.007,0,0,1,8.007,8.007",
    transform: "translate(-1153.865 -1965.986)",
    fill: "#81b4da"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M1391.3,2342.768a4.278,4.278,0,1,1-4.278-4.278,4.278,4.278,0,0,1,4.278,4.278",
    transform: "translate(-1174.946 -1987.068)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M1343.953,2284.868a6.692,6.692,0,0,0,3.952,6.151c4.261,2.165,4.261,4.261,4.261,4.261s-.412,3.23,1.924,3.3,2.474-2.956,2.268-5.43-2.061-5.017-2.44-5.636a6.623,6.623,0,0,1-.138-2.646Z",
    transform: "translate(-1141.984 -1941.504)",
    fill: "#23cccc"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 12.233,
    height: 2.818,
    transform: "translate(200.389 341.473)",
    fill: "#81b4da"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 1.897,
    height: 6.394,
    transform: "translate(205.373 335.08)",
    fill: "#13375b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M2634.914,2321.687a8.007,8.007,0,1,1-8.007-8.007,8.007,8.007,0,0,1,8.007,8.007",
    transform: "translate(-2225.34 -1965.986)",
    fill: "#81b4da"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M2653.269,2342.768a4.278,4.278,0,1,1-4.279-4.278,4.279,4.279,0,0,1,4.279,4.278",
    transform: "translate(-2247.271 -1987.068)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M2604.924,2284.868a6.692,6.692,0,0,0,3.952,6.151c4.261,2.165,4.261,4.261,4.261,4.261s-.413,3.23,1.924,3.3,2.16-3.187,1.954-5.661a12.961,12.961,0,0,0-2.125-5.4,6.626,6.626,0,0,1-.138-2.646Z",
    transform: "translate(-2213.459 -1941.504)",
    fill: "#23cccc"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 12.233,
    height: 2.818,
    transform: "translate(389.884 341.473)",
    fill: "#81b4da"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 1.897,
    height: 6.394,
    transform: "translate(394.868 335.08)",
    fill: "#13375b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M1328.337,1731.668l-74-31.75-1.206,3.179a8.132,8.132,0,0,0,4.719,10.488l70.488,29.615h133.519a8.132,8.132,0,0,0,8.132-8.133v-3.4Z",
    transform: "translate(-1064.362 -1444.459)",
    fill: "#23cccc"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M1327.678,1738.034H1469.44a8.1,8.1,0,0,0,.561-2.967v-3.4H1328.349l-74-31.75-1.206,3.179a8.1,8.1,0,0,0-.513,3.381Z",
    transform: "translate(-1064.373 -1444.458)",
    fill: "#23cccc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M2747.335,1797.726H2742.2a.913.913,0,0,1-.913-.913v-43.978a.913.913,0,0,1,.913-.913h5.138a.913.913,0,0,1,.912.913v43.978a.913.913,0,0,1-.912.913",
    transform: "translate(-2329.332 -1488.649)",
    fill: "#13375b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M1211.417,1893.074h-5.137a.913.913,0,0,1-.913-.913v-24.938a.913.913,0,0,1,.913-.913h5.137a.913.913,0,0,1,.913.913v24.938a.913.913,0,0,1-.913.913",
    transform: "translate(-1024.229 -1585.846)",
    fill: "#13375b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M1715.245,1878.618h-.58a5.471,5.471,0,0,0-5.471,5.472v19.443h11.523V1884.09a5.472,5.472,0,0,0-5.472-5.472",
    transform: "translate(-1452.341 -1596.305)",
    fill: "#5280b3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M1728.1,1898.444a4.176,4.176,0,1,1-4.176-4.176,4.175,4.175,0,0,1,4.176,4.176",
    transform: "translate(-1461.306 -1609.603)",
    fill: "#66a1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192",
    transform: "translate(256.852 294.771)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 11.523,
    height: 3.971,
    transform: "translate(0)",
    fill: "#81b4da"
  }))))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M2788.8,1597.263a4.943,4.943,0,0,1-.52,1.262,47.9,47.9,0,0,1-4.976,6.62l-2.69-6.06s.438-1.9,1.2-4.623c2.6.678,5.072,1.071,6.987,2.8",
    transform: "translate(-2362.748 -1354.85)",
    fill: "#cce2f2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M2607.321,1584.051l-20.609-3.36s2.345-5.9,3.183-5.9,15.583,6.437,15.583,6.437l1.173,2.355Z",
    transform: "translate(-2197.988 -1338.132)",
    fill: "#d2e7f3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M2597.454,2348.89s.356,5.892.358,5.9a32.394,32.394,0,0,1,.646,3.276c0,2.555-12.131-2.169-9.412-3.3.246-.1,1.535-.877,1.616-1.747.125-1.34.442-4.05.442-4.05Z",
    transform: "translate(-2199.634 -1995.905)",
    fill: "#f7a491"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M2535.582,2387.261s2.848.782,4.307.977,3.382-1.45,4.414-1.005c1.136.489,1.091,4.891,1.091,4.891s-15.273,1.253-19.568-.043c-1.7-.514,3.934-3,9.756-4.82",
    transform: "translate(-2145.99 -2028.42)",
    fill: "#184655"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M2762.589,2348.89s.356,5.892.358,5.9a32.324,32.324,0,0,1,.646,3.276c0,2.555-12.131-2.169-9.412-3.3.246-.1,1.917-1.457,2-2.326.125-1.34.058-3.471.058-3.471Z",
    transform: "translate(-2339.953 -1995.905)",
    fill: "#f7a491"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M2693.372,2387.261s2.848.782,4.307.977,3.382-1.45,4.413-1.005c1.136.489,1.182,4.891,1.182,4.891s-15.343,1.461-19.658-.043c-4.139-1.443,1.187-2.141,9.756-4.82",
    transform: "translate(-2279.113 -2028.42)",
    fill: "#184655"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M2704.092,1725.133s2.056,9.939,1.218,17.476-.9,34.307-.9,34.307l3.2,42.834-7.586.166s-9-42.813-8.828-41.714-3.016-30.145-3.016-30.145l10.724-23.865Z",
    transform: "translate(-2284.202 -1465.084)",
    fill: "#0e297f"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M2611.123,1708.681s1.341,8.949-.335,12.874-14.372,42.438-14.54,45.578-4.39,37.848-4.39,37.848l-8.821-.248-1.908-38.588,4-48.5,3.88-12.262Z",
    transform: "translate(-2193.244 -1449.104)",
    fill: "#0e297f"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 440.011,
    height: 1.954,
    transform: "translate(89.025 363.436)",
    fill: "#e9edf5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M1926.862,1621.792H1806.207a3.645,3.645,0,0,0-3.645,3.645v30.626a3.645,3.645,0,0,0,3.645,3.645h10.5v7.207h2.829v-7.207h91.605v7.207h2.829v-7.207h12.892a3.645,3.645,0,0,0,3.645-3.645v-30.626a3.644,3.644,0,0,0-3.645-3.645m-98.623,35.086h-18.332a3.644,3.644,0,0,1-3.645-3.645v-11.5h21.977Zm0-17.713h-21.977v-10.9a3.645,3.645,0,0,1,3.645-3.645h18.332Zm71.736,17.713h-69.166v-15.143h69.166Zm0-17.713h-69.166V1624.62h69.166Zm26.832,14.069a3.644,3.644,0,0,1-3.644,3.645h-20.617v-15.143h24.261Zm0-14.069h-24.261V1624.62h20.617a3.644,3.644,0,0,1,3.644,3.645Z",
    transform: "translate(-1531.68 -1378.073)",
    fill: "#13375b"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M2580.125,1531.61s-7.8,7.356-11.314,6.1-4.975-5.55,3.61-11.831c7.684-5.622,7.7,5.73,7.7,5.73",
    transform: "translate(-2180.423 -1295.246)",
    fill: "#d2e7f3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M2692.781,1401.522s.62.04.77.34,3.232,1.339,3.607,4.058-2.1,2.432-2.1,2.432Z",
    transform: "translate(-2288.117 -1190.905)",
    fill: "#f7a491"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M2634.827,1415.138l7-1.965,1.618,5.009s-6.937,5.319-6.937,5.146-1.677-8.19-1.677-8.19",
    transform: "translate(-2238.873 -1200.805)",
    fill: "#e8f1f9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M2535.91,1365.975l18.866-.859a2.4,2.4,0,0,1,2.282,1.509l7.729,23.2a1.229,1.229,0,0,1-1.224,1.669l-18.865.859a2.4,2.4,0,0,1-2.282-1.509l-7.728-23.2a1.228,1.228,0,0,1,1.224-1.669",
    transform: "translate(-2153.715 -1159.969)",
    fill: "#184655"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M2540.989,1370.76l20.043-.913,8.248,24.765-20.043.913Z",
    transform: "translate(-2159.137 -1163.99)",
    fill: "#f3faff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M2584.026,1363.257a.3.3,0,0,0-.29-.192l-8.416.383a.156.156,0,0,0-.156.212l.264.793,8.861-.4Z",
    transform: "translate(-2188.169 -1158.227)",
    fill: "#86b1f2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M2596.545,1357.92a.93.93,0,0,0-.926,1.263,1.816,1.816,0,0,0,1.728,1.142.93.93,0,0,0,.927-1.263,1.817,1.817,0,0,0-1.728-1.142m.658,1.974a1.165,1.165,0,0,1-1.108-.733.6.6,0,0,1,.594-.81,1.165,1.165,0,0,1,1.108.733.6.6,0,0,1-.594.81",
    transform: "translate(-2205.506 -1153.854)",
    fill: "#86b1f2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M2585.378,1363.147a.3.3,0,0,1,.2.18l.264.793-8.861.4a1.5,1.5,0,0,0,1.428.944l6.667-.3a.769.769,0,0,0,.766-1.044l-.264-.793a.3.3,0,0,0-.2-.18",
    transform: "translate(-2189.718 -1158.296)",
    fill: "#9bc1f9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M2575.38,1365.617h0a.166.166,0,0,0-.155.1.166.166,0,0,1,.155-.1",
    transform: "translate(-2188.228 -1160.395)",
    fill: "#9bc1f9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M2575.156,1366.416a.156.156,0,0,1,0-.037.156.156,0,0,0,0,.037",
    transform: "translate(-2188.169 -1161.043)",
    fill: "#9bc1f9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M2561.628,1404.458l12.194-.555-.124-.372-12.194.555Z",
    transform: "translate(-2176.57 -1192.613)",
    fill: "#9bc1f9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M2566.293,1418.465l12.194-.555-.124-.372-12.194.556Z",
    transform: "translate(-2180.534 -1204.514)",
    fill: "#9bc1f9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M2571.475,1434.025l12.194-.555-.124-.372-12.194.555Z",
    transform: "translate(-2184.935 -1217.735)",
    fill: "#9bc1f9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M2576.14,1448.032l12.194-.555-.124-.371-12.194.555Z",
    transform: "translate(-2188.9 -1229.637)",
    fill: "#9bc1f9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M2580.805,1462.038l12.194-.555-.124-.371-12.194.555Z",
    transform: "translate(-2192.864 -1241.539)",
    fill: "#9bc1f9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M2585.47,1476.043l12.194-.555-.124-.372-12.194.555Z",
    transform: "translate(-2196.828 -1253.439)",
    fill: "#9bc1f9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M2590.134,1490.051l12.194-.555-.124-.372-12.194.555Z",
    transform: "translate(-2200.792 -1265.342)",
    fill: "#9bc1f9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M2594.8,1504.056l12.195-.555-.124-.372-12.194.555Z",
    transform: "translate(-2204.756 -1277.243)",
    fill: "#9bc1f9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M2600.83,1521.68l14.067-.64-.124-.372-14.068.641Z",
    transform: "translate(-2209.88 -1292.146)",
    fill: "#9bc1f9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M2732.462,1458.318s13.507,8.107,13.992,7.983c.312-.08,7.649-11.5,7.711-20.7.029-4.247-4.381-9.355-9.3-8.345-2.477.509-2.439,1.2-6.1,6.523s-6.3,14.535-6.3,14.535",
    transform: "translate(-2321.836 -1221.162)",
    fill: "#d2e7f3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M2757.877,1371.142l1.376,8.7s-5.241,4.208-8.3,3.32c-2.563-.745-.805-4.1-.805-4.1s1.365-4.644.947-7.078,6.779-.845,6.779-.845",
    transform: "translate(-2336.368 -1164.657)",
    fill: "#f7a491"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M2764.777,1373.776a21.421,21.421,0,0,1-5.931,1.672,11.536,11.536,0,0,0,.139-3.456c-.193-1.123,1.236-1.389,2.831-1.35,2.087.179,3.948.505,3.948.505l.265,1.672a4.323,4.323,0,0,1-1.252.958",
    transform: "translate(-2344.255 -1164.661)",
    fill: "#fe875e"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M2744.779,1277.647c.2-.071,1.293,9.852-1.486,12.61s-8.047,3.7-9.855,1.565c-2-2.363-1.542-13.042,2.731-15.892s8.61,1.718,8.61,1.718",
    transform: "translate(-2321.695 -1083.39)",
    fill: "#f7a491"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M2744.771,1245.42a11.153,11.153,0,0,1,5.985,3.228c1.461.15,3.43.9,5.383,4.1,2.4,3.938.387,8.343-2.632,10.523a6.392,6.392,0,0,0-2.862,5.145l-1.119-2.815a10.073,10.073,0,0,1,.765-3.8c.757-1.444-1.444-2.379-2.03-3.57-.451-.917-.406-3.024-1.114-4.54,0,0-2.877-2.173-4.97-2.22-3.568-.08-1.527-6.814,2.593-6.054",
    transform: "translate(-2328.53 -1058.21)",
    fill: "#13375b"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M2768.358,1290.485a6.439,6.439,0,0,1,1.585,4.7c-.3,2.705-1.8,7.664-.6,9.017s5.124,2.746,5.124,2.746l1.638-9.809a44.5,44.5,0,0,0-1.653-4.658c-.3-.3-6.094-2-6.094-2",
    transform: "translate(-2352.338 -1096.554)",
    fill: "#13375b"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M2766.549,1322.425c-.061,1.212.489,2.2,1.23,2.2s1.39-.973,1.452-2.186-.489-2.2-1.229-2.2-1.39.974-1.452,2.186",
    transform: "translate(-2350.797 -1121.836)",
    fill: "#f7a491"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M2762.577,1415.987a7.923,7.923,0,0,1-4.2,1.262c-2.029-.165-4.9-2.037-4.9-2.037l.4-1.351s5.248-.765,5.38-.682,3.322,2.809,3.322,2.809",
    transform: "translate(-2339.692 -1200.805)",
    fill: "#f7a491"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M2679.91,1413.5s-2.555-.751-3.156-1.052-1.051.6-.45,1.2a15.794,15.794,0,0,0,2.14,1.85,3.186,3.186,0,0,0,1.829.463Z",
    transform: "translate(-2273.876 -1200.14)",
    fill: "#f7a491"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M2582.262,1456.982c1.158-6.3,9.551-25.906,10.221-29.517.326-1.756,4.853-1.8,9.165-1.566,4.554.242,9.079.818,9.079.818s4.032.662,5.806,2.324,2.245,6.259-.3,14.986c-2.013,6.889-4.509,10.672-5.744,15.689-.25,1.683-.465,3.344-.749,5.284-.454,7.5.991,66.008.991,66.008s-27.746,5.726-35.957-1.183c0,0,6.3-66.39,7.491-72.845",
    transform: "translate(-2187.843 -1211.534)",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M2570.13,1449.614s8.952,4.19,9.455,4.19c.324,0,14.543-10.638,17.306-17.871,1.527-4-1.676-8.471-5.335-8.456-2.536.01-3.663.664-8.69,4.9s-12.735,17.234-12.735,17.234",
    transform: "translate(-2183.898 -1212.96)",
    fill: "#d2e7f3"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 629.534,
    height: 365.39,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.5f9a3c1e068e1b7ea83bacc810faf372.svg";
export { ForwardRef as ReactComponent };